import mitt from 'mitt'
// const emitter = mitt()
// export default emitter
export const widgetEvent = mitt()
